<template>
  <div>
    <div class="overlay">
      <div class="overlay-body">
        <div v-if="$route.name === 'Other'">
          <div class="other-text">今月の健康度チェック<br />は完了しています。</div>
          <div class="img-style">
            <img src="@/assets/アセット 9@2x.png" @click="close"/>
          </div>
        </div>
        <div v-else>
          <p class="overlay-text-style conformation">確認画面</p>
          <p class="overlay-text-style">入力した情報で<br />登録してもいいですか？</p>
          <div class="margin-top-40">
            <button class="yes" @click="complete">はい</button>
            <button class="no" @click="cancel">いいえ</button>
          </div>
          <p class="text-b">※入力した全ての情報は<br />後から変更できます</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowDialog",
  methods: {
    cancel() {
      this.$emit("pushedCancel");
    },
    complete() {
      this.$emit("handle-submit")
    },
    close() {
      this.$emit("handle-hide-dialog")
    }
  },
};
</script>

<style scoped>
.overlay {
  /*要素を重ねた時の順番*/
  z-index: 4;
  /*画面全体を覆う設定*/
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
}
.overlay-body {
  background: white;
  margin: 100px 15px 0 15px;
  border-radius: 5px;
  height: 65%;
  padding: 15px;
}

.overlay-body button {
  font-size: 1.2rem;
  border-radius: 20px;
  padding: 8px 28px;
  border-style: none;
  min-width: 110px;
  font-weight: bold;
}
.overlay-body .yes {
  background-color: orange;
  color: white;
  margin: 10px 20px 20px 0px;
}
.overlay-body .no {
  background-color: gainsboro;
}
.overlay-body .text-b {
  display: inline-block;
  margin-top: 50px;
  color: gray;
}
.overlay-text-style {
  font-size: 1.2rem;
  font-weight: bold;
  color: #000;
}
.conformation {
  color: #00a0b9;
  display: inline-block;
}
.margin-top-40 {
  margin-top: 40px;
}
.other-text {
  font-size: 2rem;
  font-family: monospace;
  margin: 5em 0 1em 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ShowDialog.vue